<template>
  <v-dialog
    persistent
    v-model="attachmentDialog"
    max-width="40%"
    :fullscreen="$vuetify.breakpoint.mobile"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-on="on"
        v-bind="attrs"
        :disabled="isReadonly"
        color="primary"
        class="text-capitalize"
      >
        <v-icon class="mx-2">add</v-icon>
        {{ BtnCaption }}
      </v-btn>
    </template>
    <v-card class="mx-auto">
      <v-card-title> Attach A document </v-card-title>
      <v-card-text>
        <v-form v-model="isValid" ref="refundAttachment">
          <v-textarea
            rows="3"
            outlined
            v-model="comment"
            placeholder="Attach Refund Proof"
            label="Comment"
            maxlength="100"
            persistent-placeholder
            dense
            :rules="rule.comment"
          ></v-textarea>
          <v-file-input
            accept="image/jpeg,image/png,application/pdf"
            v-model="attachmentBlob"
            prepend-icon=""
            append-icon="mdi-paperclip"
            outlined
            counter
            :show-size="1000"
            chips
            :rules="rule.attachment"
            :clearable="true"
            label="Upload Attachment"
            ref="uploadAttachment"
          >
            <template v-slot:selection="{ text }">
              <v-chip small label>
                {{ text }}
              </v-chip>
            </template>
          </v-file-input>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn text color="deep-orange" @click="attachmentDialog = false">
          <v-icon class="mx-1">cancel</v-icon>
          Cancel
        </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          class="text-capitalize"
          width="30%"
          @click="save"
        >
          Attach
          <v-icon class="mx-2">save</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { helper } from "@/packages/dashboard/utils";

export default {
  name: "RefundAttachments",
  props: {
    isEdit: Boolean,
    BtnCaption: String,
    isReadonly: Boolean,
    data: Object,
  },
  data: function () {
    return {
      isValid: false,
      comment: "",
      attachmentBlob: null,
    };
  },
  computed: {
    rule() {
      return {
        attachment: [
          (value) => !!value || "Attachment is required!",
          (value) =>
            !value ||
            value.size < 5242880 ||
            "Each file size should be less than 5 MB!",
          (value) => !value || value.size < 5242880 || false,
        ],
        comment: [
          (value) => !!value || "Attachment Comment is required!",
          (value) =>
            (value && value.length) < 100 ||
            "Less than 100 characters required!",
        ],
      };
    },
    attachmentDialog: {
      get() {
        return this.$store.getters["Refund/refundGetter"]("attachmentDialog");
      },
      set(val) {
        this.$store.dispatch("Refund/setAttachmentDialog", val);
      },
    },
  },
  methods: {
    async save() {
      if (!this.isValid) {
        this.$refs.refundAttachment.validate();
      } else {
        let attachment = await helper.toBase64(this.attachmentBlob);
        const file = {
          base64Attachment: attachment.split(",")[1],
          fileName: this.attachmentBlob.name,
          blob: this.attachmentBlob,
          comment: this.comment,
          index: this.data.index,
        };
        this.$emit("addAttachment", file);
        this.attachmentDialog = false;
        this.$refs.refundAttachment.reset();
      }
    },
  },
  watch: {
    data() {
      this.comment = this.data.comment;
      this.attachmentBlob = this.data.blob;
    },
  },
};
</script>

<style scoped></style>
